var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('header-component'),_c('div',{staticClass:"not-found"},[_c('card-component',{staticClass:"card",attrs:{"styles":_vm.notFoundData}})],1),_c('footer-component')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }